export class PagingSize {
  constructor(page: number, pageSize: number) {
    this.page = page;
    this.pageSize = pageSize;
  }
  pageSize: number;
  page: number;
}
